import { Dispatch, SetStateAction, useState } from "react";
import Input from "../lib/Input";
import CostColumns from "../lib/CostColumns";
import OperationLayout from "../lib/OperationLayout";
import Dimensions from "../lib/Dimensions";
import VolumeDiscount from "../lib/VolumeDiscount";
import useOperationContext from "../lib/useOperationContext";
import OperationHeader from "../lib/OperationHeader";
import EditableCostColumns from "../lib/EditableCostColumns";
import { hasSomeValidationErrorsInFields } from "../lib/getValidationErrors";
import { components } from "@/lib/ApiSchema";

export default function FinishingOperationAreaDependent() {
  const { operationData: data } = useOperationContext();
  const { id, validation_errors, name, type } = data;
  const expandByDefault = hasSomeValidationErrorsInFields({
    errors: validation_errors,
    expandedPanelFields: [
      "requirements_standard",
      "type",
      "class_",
      "color",
      "part_dimensions",
      "discount_rates",
      "markup",
    ],
  });
  const [expand, setExpand] = useState(expandByDefault);

  return (
    <OperationLayout
      id={id as string}
      left={
        <Left name={name} expand={expand} setExpand={setExpand} type={type} />
      }
      right={<Right expand={expand} />}
    />
  );
}

function Left({
  name,
  expand,
  setExpand,
  type,
}: {
  name: string;
  expand: boolean;
  setExpand: Dispatch<SetStateAction<boolean>>;
  type: components["schemas"]["CalculatorTypeEnum"];
}) {
  return (
    <div className="w-full flex flex-col p-2 pb-1 gap-2 items-start">
      <OperationHeader
        type={type}
        name={name}
        expand={expand}
        setExpand={setExpand}
      />
      <div className="w-full flex gap-2">
        <Input
          label="Part Surface Area"
          keyPath={["part_surface_area"]}
          unit="area"
          width={115}
        />
        <Input label="Cost" keyPath={["cost"]} nunit="currency" dunit="area" />
        <Input
          label="Min. Batch"
          keyPath={["min_batch_cost"]}
          unit="currency"
        />
      </div>
      {expand && (
        <div className="w-full flex flex-col gap-2">
          <div className="flex gap-2">
            <Input label="Type" keyPath={["type"]} width={50} />
            <Input label="Class" keyPath={["class_"]} width={50} />
            <Input label="Color" keyPath={["color"]} width={50} />
            <Input
              label="Requirements Standard"
              keyPath={["requirements_standard"]}
              width={145}
            />
          </div>
          <div className="flex justify-start">
            <Dimensions
              columns={["Length", "Width", "Height"]}
              rows={[
                {
                  label: "Part",
                  keyPaths: [
                    ["part_dimensions", "length"],
                    ["part_dimensions", "width"],
                    ["part_dimensions", "height"],
                  ],
                },
              ]}
            />
          </div>
          <div className="w-full flex justify-between">
            <VolumeDiscount />
            <div className="self-end flex flex-col items-end gap-6">
              <div className="text-xs text-gray-400">Cost</div>
              <Input
                label="Markup"
                keyPath={["markup"]}
                suffix="%"
                width={60}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function Right({ expand }: { expand: boolean }) {
  return (
    <>
      {expand && <EditableCostColumns />}
      <CostColumns />
    </>
  );
}
